const CAP14 = {
  "id": 34,
  "title": "Cómo guardar y usar los bitcoin: las Wallet",
  "subtitle": "Curso GRATIS de BITCOIN con CERTIFICADO",
  "sections": [
     {
      "heading": "Dónde se guardan las transacciones entre usuarios",
      "text": [
  
        "El concepto de “blockchain” se introdujo inicialmente en 1991 por un grupo de investigadores (Stuart Haber y W. Scott Stornetta), quienes investigaban una forma de aplicar marcas de tiempo o “timestamp” en documentos que no pudieran ser modificados. Años después, blockchain empezó a tener más importancia cuando fue utilizado por Satoshi Nakamoto en 2009 para crear la famosa criptomoneda digital Bitcoin.",
        "Blockchain es un libro mayor distribuido que está completamente abierto a cualquier persona y, una vez que registra datos (transacciones) dentro de la cadena de bloques, es prácticamente imposible cambiarlos.",
        "Tipos de bloque blockchain",
        "¿Sabes cómo funciona una cartilla de banco?",
        "En ella se apuntan las operaciones de forma sucesiva en cada hoja hasta llenarse y, una vez completa, se pasa a la siguiente hoja. La cadena de bloques funciona de forma similar. Cada bloque equivaldría a una hoja de la cartilla. El conjunto de estos bloques se le llama cadena o blockchain y equivaldría a la cartilla.",
        "¡Espera! Sí es como una cartilla de banco, ¿Dónde está la novedad?",
        "¡Muy fácil! Lo realmente ingenioso es que esta cartilla (blockchain) es la misma para todos los usuarios. En Bitcoin, todos compartimos la misma cartilla mediante esta cadena de bloques y, además, la información de los bloques es pública.",
        "Como este libro de cuentas es público, tú y cualquier persona que quiera puede acceder a él a cualquier hora del día. De esta forma es muy fácil verificar si todo está en orden con el saldo tu cuenta o el estado de tus transacciones. También puedes comprobar así sí se cumplen las reglas del juego.",
        "Algunos aspectos importantes sobre Blockchain (lo que lo hace tan innovador):"
      ],
      "list": [
        "No hay autoridad central para administrar esta base de datos. Esto dificulta que un hacker corrompa los datos.",
        "Es una base de datos de sólo agregar, por lo que no se puede realizar ninguna modificación después de insertar los datos.",
        "Sistema distribuido “peer to peer” (P2P).",
        "Mayor eficiencia y transparencia.",
        "Utiliza criptografía para generar confianza, responsabilidad y seguridad.",
        "Utiliza un mecanismo de consenso (PoW) para validar las transacciones.",
        "Es de Código abierto, lo que significa que está disponible gratuitamente para todos."
      ]
    },
   
    {
      "heading": "Tipos de bloque blockchain",
      "text": [
        "¿Sabes cómo funciona una cartilla de banco?",
        "En ella se apuntan las operaciones de forma sucesiva en cada hoja hasta llenarse y, una vez completa, se pasa a la siguiente hoja. La cadena de bloques funciona de forma similar.",
        "Cada bloque equivaldría a una hoja de la cartilla. El conjunto de estos bloques se le llama cadena o blockchain y equivaldría a la cartilla.",
        "Lo ingenioso es que esta ‘cartilla’ es compartida entre todos los usuarios y que la información de los bloques es pública."
      ]
    },
    {
      "heading": "Aspectos innovadores de la Blockchain",
      "list": [
        "No hay autoridad central para administrar esta base de datos.",
        "Es una base de datos de sólo agregar, por lo que no se puede realizar ninguna modificación después de insertar los datos.",
        "Sistema distribuido peer to peer (P2P).",
        "Mayor eficiencia y transparencia.",
        "Utiliza criptografía para generar confianza, responsabilidad y seguridad.",
        "Utiliza un mecanismo de consenso (PoW) para validar las transacciones.",
        "Es de Código abierto, lo que significa que está disponible gratuitamente para todos."
      ]
    },
    {
      "heading": "Cómo guardar y usar los bitcoin: las Wallets",
      "text": [
        "En el mundo de las criptomonedas se les llama wallets a los monederos especiales para guardar bitcoin u otras criptomonedas.",
        "Por tanto, lo primero para poder tener bitcoin es hacerte con una de estas carteras especiales.",
        "Lo bueno de estas carteras es que son totalmente gratis y de libre acceso.",
        "Además, están disponibles para los principales tipos de dispositivos como teléfonos Android, iOS y ordenadores con sistemas operativos como Windows, Linux y MacOs."
      ]
    },
    {
      "heading": "¿Cómo funcionan las Wallets?",
      "text": [
        "Una vez tengas la cartera, como es evidente, esta estará vacía, sin fondos. Por lo que no podrás hacer operaciones con ella aún.",
        "No te preocupes, esto también tiene fácil solución, puesto que sólo necesitas recibir bitcoin para poder empezar a hacer pagos, donar cantidades a quien quieras o simplemente mantenerlos almacenados."
      ]
    },
    {
      "heading": "Primeros pasos con tu Wallet",
      "text": [
        "Si quieres empezar a conocer el funcionamiento de la blockchain y del mundo de las criptomonedas puedes crear ya tu wallet a través de nuestra academia de forma gratuita para que pongas en práctica todo lo que vayas aprendiendo."
      ]
    },
   
    {
      "heading": "Cómo guardar y usar los bitcoin: las Wallets",
      "text": [
       
        "En el mundo de las criptomonedas se les llama wallets a los monederos especiales para guardar bitcoin u otras criptomonedas. Por tanto, lo primero para poder tener bitcoin es hacerte con una de estas carteras especiales. Lo bueno de estas carteras es que son totalmente gratis y de libre acceso.",
        "Además, están disponibles para los principales tipos de dispositivos como teléfonos Android, iOS y ordenadores con sistemas operativos como Windows, Linux y MacOs.",
        "Una vez tengas la cartera, como es evidente, esta estará vacía, sin fondos. Por lo que no podrás hacer operaciones con ella aún. No te preocupes, esto también tiene fácil solución, puesto que sólo necesitas recibir bitcoin para poder empezar a hacer pagos, donar cantidades a quien quieras o simplemente mantenerlos almacenados.",
        "Si quieres empezar a conocer el funcionamiento de la blockchain y del mundo de las criptomonedas puedes crear ya tu wallet a través de nuestra academia de forma gratuita para que pongas en práctica todo lo que vayas aprendiendo.",
        "Si lo deseas puedes solicitar el soporte de nuestro equipo de expertos, que te ayudará en tus primeros pasos y te dará la asesoría profesional que necesites."
      ]
    },
     {
      "heading": "¿Qué es una Hardware Wallet?",
      "text": [
        "Las hardware wallets son dispositivos físicos diseñados específicamente para almacenar de forma segura las claves privadas de tus criptomonedas SIN conexión a Internet.",
        "Pertenecen al grupo de Cold Wallets o almacenamiento en frío, ya que no están conectadas a la red ni a la blockchain de forma directa.",
        "Funcionan como pequeñas unidades HSM (Módulos Hardware de Seguridad), con protección de grado militar que impide que las claves sean copiadas o extraídas."
      ]
    },
    {
      "heading": "Máxima seguridad",
      "text": [
        "Las claves privadas se generan dentro del dispositivo y NUNCA salen de él.",
        "Si alguien intenta manipular físicamente el dispositivo, muchas hardware wallets ejecutan un 'autoborrado' que destruye automáticamente las claves almacenadas.",
        "Son ideales para almacenar grandes cantidades de criptomonedas, ya que combinan alto nivel de seguridad y facilidad de uso."
      ]
    },
    {
      "heading": "Funciones principales",
      "list": [
        "🛡️ Generar las claves privadas dentro del dispositivo (de forma segura y aislada).",
        "✍️ Firmar transacciones utilizando esas claves privadas, sin revelarlas nunca.",
        "🔎 Mostrar en su pantalla integrada los datos de la transacción para verificar antes de confirmar.",
        "🔌 Facilitar una conexión segura con el ordenador o smartphone mediante USB o Bluetooth."
      ]
    },
    {
      "heading": "¿Cómo se utilizan?",
      "text": [
        "1️⃣ Conecta la hardware wallet a tu ordenador o smartphone mediante USB o Bluetooth.",
        "2️⃣ Abre el software compatible (como Ledger Live, Trezor Suite, etc.).",
        "3️⃣ Introduce el PIN que protege el dispositivo.",
        "4️⃣ Para enviar criptomonedas, el ordenador prepara la transacción, pero la firma se realiza dentro de la hardware wallet.",
        "5️⃣ La firma se devuelve al ordenador ya protegida, sin revelar la clave privada.",
        "6️⃣ Una vez enviada la transacción, puedes desconectar el dispositivo. Tus criptomonedas siguen seguras en la blockchain."
      ]
    },
    {
      "heading": "Ventajas de las hardware wallets",
      "list": [
        "🔒 Seguridad máxima contra hackeos y malware.",
        "🌐 No requieren conexión permanente a Internet.",
        "🗝️ Las claves privadas nunca se exponen al exterior.",
        "🖥️ Fácil integración con software de gestión de criptomonedas.",
        "📦 Compactas, portátiles y fáciles de almacenar o transportar."
      ]
    },
  ]
}

export default CAP14;
